export default __webpack_public_path__ + "static/media/icone-bill.07d72553.svg";